module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body'>\r\n       <ul>\r\n         <li><a [routerLink]=\"['/new-year-rollover-steps']\">New Year Rollover Steps</a></li>\r\n         <li><a [routerLink]=\"['/new-year-rollover-reports']\">New Year Rollover Reports</a></li>\r\n       </ul>\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/system-management/new-year-rollover/new-year-rollover.component.html
 ** module id = 847
 ** module chunks = 0
 **/